import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import inputValidation from "../../../utils/inputValidation";
import { api } from "../../../redux/api";
import { treeActions } from "../../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { newTemplateActions } from "../../../redux/slices/newTemplateSlice";

function CopyInboundTemplate(props) {
  const dispatch = useDispatch();
  const { openModal, toggle } = props;
  const { t } = useTranslation();
  const { account } = useSelector((state) => state.queryParams);
  const parentScreen = useContext(ParentScreenCtx);
  const { leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const sourceWorkflowName = leftTree.tree.body.selectedNode?.workflowGroup;
  const sourceTemplateName = leftTree.tree.body.selectedNode?.title;
  const destinationWorkflowName = leftTree.tree.body.selectedNode?.workflowGroup;
  const error = useRef();
  const [newTemplate,setNewTemplate] = useState('');
  const [valid, setValid] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState('userspace');
  const currentScreen = useSelector(state => state.treeData.currentScreen)
  const handleOkClick = () => {
    if (validateInput()) {
      let dispatchTree = currentScreen === 'inbound' ? 'getInboundTemplateList' : currentScreen === 'outbound' ? 'getOutboundTemplateList' : 'getWorkflows';
      let dispatchType = currentScreen === 'workflow' ? 'copyWorkflowTemplate' : 'copyInboundTemplate';
      if (selectedLocation) {
        dispatch(
          api.endpoints[dispatchType].initiate({
            account,
            sourceWorkflowName,
            sourceAccount: account,
            sourceTemplateName,
            destinationWorkflowName,
            newTemplateName: newTemplate,
            is_overwrite: "",
            is_userspace: selectedLocation === 'userspace',
            is_server: selectedLocation === 'server',
            is_inbound: currentScreen === 'inbound'
          })
        ).then((response) => {
          if (response.data.current_state === "SUCCESS") {
            dispatch(newTemplateActions.setShowAlert(true));
            dispatch(newTemplateActions.setAlertType('success'))
            dispatch(newTemplateActions.setAlertMessage(response.data.message));
            dispatch(
              treeActions.setLeftTreeContextActionValue({
                screen: parentScreen,
                data: {
                  name: response?.data?.data.template_name || response?.data?.data?.workflow_name,
                  workflowGroup: sourceWorkflowName,
                }
              })
            );
            dispatch(
              api.endpoints[dispatchTree].initiate(
                { account },
                { subscribe: false, forceRefetch: true}
              )
            );
            toggle();
          } else {
            dispatch(newTemplateActions.setShowAlert(true));
            dispatch(newTemplateActions.setAlertType('error'));
            dispatch(newTemplateActions.setAlertMessage(response.data.message || t("BOX_MSG_GENERAL_ERROR")))
            error.current.textContent = response.data.message;
            setValid(false);
          }
        });
      }
    }
  };
  const handleCancelClick = () => {
    setValid(true);
    props.toggle();
  };
  const validateInput = () => {
    let inputFieldValue = newTemplate;
    if (inputValidation(inputFieldValue) === "") {
      error.current.textContent = t("BOX_ENTER_NEW_NM_FOR_IN_TEM");
      setValid(false);
      return false;
    } else if (inputValidation(inputFieldValue) === "invalid") {
      error.current.textContent = t("BOX_TEM_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES")
      setValid(false);
      return false;
    } else if(inputFieldValue.length > 50){
      const errorMsg = t("BOX_MAX_LENGTH_FOR_NAME_IS").replace(/\{0\}/, "50");
      error.current.textContent = errorMsg;
      setValid(false);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (error?.current && (selectedLocation)) {
      error.current.textContent = ''
    }
  }, [selectedLocation])


  return (
    <>
      <Dialog open={props.openModal} maxWidth="xs">
        <DialogTitle className="dialog-header">
          <div className="title">
           { currentScreen === 'inbound' ? t("DIAG_INBOUND_WIZARD4_COPY_TIT") : currentScreen === 'outbound' ? t('DIAG_OUTBOUND_WIZARD4_COPY_TIT') : t('DIAG_WORKFLOW_WIZARD3_COPY_TIT') }
          </div>
          <div className="description">
            {currentScreen === 'inbound' ? t("DIAG_RENAME_INBOUND_TEMPLATE_DESC") : currentScreen === 'outbound' ? t('DIAG_OUTBOUND_WIZARD4_DESC') : t('DIAG_WORKFLOW_WIZARD3_DESC')}
          </div>
        </DialogTitle>
        <DialogContent className="modal-content" dividers>
          <div className={"default-delimiter-field"}>
            <TextField
              variant="outlined"
              size="small"
              autoFocus={true}
              label={currentScreen === 'inbound' ? t("LBL_IN_TEM_NM"): currentScreen === 'outbound'? t('LBL_OUT_TEM_NM') : t('LBL_WF_NM')}
              value={newTemplate}
              error={!valid}
              onChange={(e) => {
                setNewTemplate(e.target.value);
                error.current.textContent = "";
                setValid(true);
              }}
            />
          </div>
          <p className="error" ref={error}></p>
        </DialogContent>
        <DialogActions>
          <FormControl className="flex justify-start width-100">
            <RadioGroup
              row
              aria-labelledby="copy-location"
              name="copy-location-btn"
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}>
              <FormControlLabel
                value="userspace"
                control={<Radio />}
                label={t("USERSPACE")}
              />
              <FormControlLabel
                value="server"
                control={<Radio />}
                label={t("SERVER")}
              />
            </RadioGroup>
          </FormControl>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={!valid}
            onClick={handleOkClick}>
            {t("FINISH")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={handleCancelClick}
          >
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CopyInboundTemplate;
